import React from 'react';
import SplashScreen from '../common/Splash/screen';
import experiences from './experience.json';

const Experiences = () => {
    const logos = []

    const expandDiv = (event) => {
        let target = event.target
        let parent = target.parentElement
        console.log(parent)
        let more = parent.children[1]
        if (more.style.display === "none") {
            more.style.display = "flex"
            target.innerHTML = "View Less"
        } else {
            more.style.display = "none"
            target.innerHTML = "View More"
        }
    }

    const proExperienceList = experiences.professional.map((experience, idx, arr) => {
        logos.push( <img className='splash_icon' src={process.env.PUBLIC_URL + experience.logo.short} alt={experience.organization} /> )
        let tasks = experience.tasks.map((task) => {
            return <li className='achv_list'><div dangerouslySetInnerHTML={{__html: task}} /></li>
        })

        let scrpt = experience.technologies.scripting.map((task) => {
            return <div className='achv_list'>{task}</div>
        })
        let dvops = experience.technologies.devops.map((task) => {
            return <div className='achv_list'>{task}</div>
        })
        let tools = experience.technologies.tools.map((task) => {
            return <div className='achv_list'>{task}</div>
        })
        let ai = experience.technologies.ai.map((task) => {
            return <div className='achv_list'>{task}</div>
        })

        let notable = experience.notable.map((task) => {
            return <p className='notable'>• {task}</p>
        })

        let hSkills = experience.skills.map((task) => {
            return <div className='hard_skills'>{task}</div>
        })
        let sSkills = experience.soft_skills.map((task) => {
            return <span className='soft_skills'>• {task}</span>
        })

        let mgt = 20;
        let mgb = 20;

        if (idx != arr.length - 1 && arr[idx + 1].organization == experience.organization) {
            mgb = 1
            mgt = 20
        }
        else if (idx != 0 && arr[idx - 1].organization == experience.organization) {
            mgt = 1
            mgb = 20
        }
        else {
            mgt = 20
            mgb = 20
        }

        return (
            <div className='exp_card' style={{marginTop: mgt, marginBottom: mgb}}>
                <div className='center' style={{width: "100%"}}>
                    <div className='flex_column exp_years'>
                        <img src={process.env.PUBLIC_URL + experience.logo.long} alt={experience.organization} />
                        <div className=''>{experience.start} <p className="to">to</p> {experience.end}</div>
                        <div className='exp_place'>{experience.place}</div>
                        
                    </div>
                    <div className='exp_details center'>
                        <div className='exp_header'>
                            <div className='exp_org'>{experience.organization}</div>
                            <div className='exp_dept'>{experience.department}</div>
                            <div className='exp_pos'>{experience.role}</div>
                            <div className='center'>
                                <div className='exp_notable flex_column'>
                                    {[notable]}
                                </div>
                                <div className='exp_skills'>
                                    {[hSkills]}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='center more' style={{textAlign: "left", alignItems: "flex-start", display: "none"}}>
                    <div className='flex_column' style={{width: "25%"}}>
                        <div className='skills'>
                            {scrpt.length === 0? null: <p className='exp_sub'>Programming & Scripting</p>}
                            {[scrpt]}
                            {dvops.length === 0? null: <p className='exp_sub'>DevOps & Automation</p>}
                            {[dvops]}
                            {ai.length === 0? null: <p className='exp_sub'>AI & ML</p>}
                            {[ai]}
                            {tools.length === 0? null: <p className='exp_sub'>Tools</p>}
                            {[tools]}
                        </div>
                    </div>
                    <div className='exp_details' style={{width: "75%"}}>
                        <div className='exp_desc'>{experience.description}</div>
                        <ul>{[tasks]}</ul>
                        {[sSkills]}
                    </div>
                </div>
                <div className='read_more' onClick={expandDiv}>View More</div>
            </div>
        )
    })
    const extraExperienceList = experiences.extracurricular.map((experience) => {
        logos.push( <img className='splash_icon' src={process.env.PUBLIC_URL + experience.logo.short} alt={experience.organization} /> )
        let achievements = experience.achievements.map((achievement) => {
            return <p className='achv_list'>{achievement}</p>
        })
        return (
            <div className='extra_exp'>
                <div className='exp_details center'>
                    <div className='exp_header'>
                        <div className='center flex_column'>
                            <div className='exp_org'>{experience.organization}</div>
                            <div className='exp_dept'>{experience.department}</div>
                        </div>
                        <div className='exp_pos'>{experience.role}</div>
                        <div className='exp_desc' style={{margin: 40}}>{experience.description}</div>
                    </div>
                    <div className='center flex_column'>
                        <img className='exp_icon' src={process.env.PUBLIC_URL + experience.logo.short} alt={experience.organization} />
                        <div className='exp_year'>
                            {experience.start} <span className="to">to</span> {experience.end}
                        </div>
                        <div className='exp_high'>
                            {[achievements]}
                        </div>
                    </div>
                </div>
            </div>
        )
    })
    const volunteerExperience = experiences.volunteer.map((experience) => {
        logos.push( <img className='splash_icon' src={process.env.PUBLIC_URL + experience.logo.short} alt={experience.organization} /> )
        return (
            <div className='volunteer_exp'>
                <div className='exp_year center'>
                    {experience.start} <span className="to">to</span> {experience.end}
                </div>
                <div className='exp_details center flex_column'>
                    <div className='exp_header' style={{margin: 20}}>
                        <div className='exp_pos'>{experience.role}</div>
                        <div className='exp_org'>{experience.organization}</div>
                        <div className='exp_dept'>{experience.department}</div>
                    </div>
                    <p style={{margin: 20}}>{experience.description}</p>
                </div>
                <img className='exp_icon' src={process.env.PUBLIC_URL + experience.logo.short} alt={experience.organization} />
            </div>
        )
    })

    return (
        <div id='experiences'>
            <SplashScreen name="Experiences" bgColor="white" color="#641289" photo="/assets/experiences/all3.png" />
            <div className='center splash_cr'>
                {[logos]}
            </div>
            <div className='center'>
                <div className='exp_left'>
                    <div className='exp_filter'>

                    </div>
                </div>
                <div className='exp_right'>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Professional Experience
                                <div className='poster_hr'/>
                            </div>
                        </div>
                        <div className='project_list' style={{flexWrap: "wrap", justifyContent: "flex-start"}}>
                            {[proExperienceList]}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Extra-Curricular Experience
                                <div className='poster_hr'/>
                            </div>
                        </div>
                        <div className='project_list' style={{flexWrap: "wrap", justifyContent: "flex-start"}}>
                            {[extraExperienceList]}
                        </div>
                    </div>
                    <div className='center' style={{width: "95vw", justifyContent: "flex-start", alignItems:"flex-start", alignItems:"flex-start"}}>
                        <div className='container' style={{marginLeft: "5vh", marginTop: "5vh"}}>
                            <div className='poster'>
                                Volunteer Experience
                                <div className='poster_hr'/>
                            </div>
                        </div>
                        <div className='project_list center' style={{flexWrap: "wrap", justifyContent: "flex-start", margin: "2vw", marginTop: 0}}>
                            {[volunteerExperience]}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Experiences;